import ACTIONS from '../actionTypes/user';

const initialState = {
  DisplayName: '',
  Email: '',
  GlobalIdentity: '',
  ID: '',
  LastLogin: '',
  PhoneNumber: '',
  UserName: '',
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.CLEAR_USER_INFO: {
      return {
        ...initialState
      };
    }
    case ACTIONS.UPDATE_USER_CURRENT_SESSION:
      return {
        ...state,
        ...action.payload,
        DisplayName: action.payload.DisplayName || '',
        Email: action.payload.Email || '',
        GlobalIdentity: action.payload.GlobalIdentity || '',
        ID: action.payload.ID || '',
        LastLogin: action.payload.LastLogin || '',
        PhoneNumber: action.payload.PhoneNumber || '',
        UserName: action.payload.UserName || '',
      };
    case ACTIONS.UPDATE_USER_DATA_FROM_TOKEN:
      return {
        ...state,
        ...action.payload,
        Email: action.payload.Email || '',
        GlobalIdentity: action.payload.GlobalIdentity || '',
      };
    default:
      return state;
  }
}
